import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { ApplicationReviewItem } from 'app/models/dto/borrower-fd/application-review.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class ApplicationReviewService {

  constructor(private http: ApiHttpClient) { }

  // gets application review requirements
  getApplicationReviewItems(borrowerId: number): Observable<ApplicationReviewItem[]> {
    return this.http.get<ApplicationReviewItem[]>(`${environment.API_URL}/borrower/${borrowerId}/application-review`);
  }

}
